import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Dropoff = lazy(() => import('./dropoff/dropoff.component'));

export function MyLaundryRoutes() {
    return (
        <>
            <Route path='send_dirty_laundry'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <Dropoff />
                        </AsyncComponent>
                    }
                />
            </Route>
        </>
    );
}
